import React, { useEffect } from 'react';
import { Button } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardBody,
    CardFooter,
    Typography,
} from "@material-tailwind/react";
import '../styles/lines.css'
import Contact from '../components/Contact';
const services = [
    {
        title: '12',
        description: 'Years of hands-on experience',
        icon: <img src="/Group-114.png" alt="icon" />,
    },
    {
        title: '450+',
        description: 'Happy, long-term clients',
        icon: <img src="/Group-112.png" alt="icon" />,
    },
    {
        title: '40+',
        description: 'US and EU countries we deliver solutions to',
        icon: <img src="/Group-113.png" alt="icon" />,
    },
    {
        title: '8',
        description: 'Office locations across North America and Europe',
        icon: <img src="/Group-111.png" alt="icon" />,
    },
];
const services2 = [
    {
        title: 'Custom software development',
        description: 'Our team of experts delivers software solutions, taking care of everything from start to finish. We’ll make sure the whole system is set up just right and favors scalability. And if there are any neat features missing, we’ll totally pump up your existing software to make it even better.',
        image: 'img-0005.jpg',
    },
    {
        title: 'All-round consulting',
        description: 'If you’re facing any issues with your software systems, project workflows, or processes and require a thorough check-up, our project expertise of almost two decades can really come in handy! We can provide you with a comprehensive 360-degree audit, covering everything from requirements management to quality assurance.',
        image: 'img-0006.jpg',
    },
    {
        title: 'Innovations that matter',
        description: 'Our enthusiastic R&D department, with more than a decade of experience and over 40 R&D-pioneered projects behind it, is totally on top of the latest tech, constantly checking out all the cool trends and figuring out if they’re feasible for your project. Which know-hows will rock your business case? We’ll give you the answer.',
        image: 'img-0007.jpg',
    },

];
const domains  = [
    {
        title: 'Blended Learning',
        description: 'Transforming education through interactive, technology-driven learning experiences that seamlessly integrate traditional and digital methods.',
        image: '3.jpg',
    },
    {
        title: 'ERP Systems',
        description: 'Optimizing business operations with powerful, industry-specific Enterprise Resource Planning solutions for enhanced efficiency and decision-making.',
        image: '2.jpg',
    },
    {
        title: 'E-commerce Solutions',
        description: 'Building secure, scalable e-commerce platforms that elevate online shopping, boost sales, and enhance customer engagement.',
        image: '12.jpg',
    },
    {
        title: 'AEC & IT Integration',
        description: 'Merging architecture, engineering, and construction with advanced technology to enhance precision, efficiency, and digital transformation.',
        image: '9.webp',
    },

    {
        title: 'Agricultural Technology',
        description: 'Revolutionizing agriculture with smart farming, IoT-based monitoring, and AI-driven insights for better productivity and sustainability.',
        image: '8.jpg',
    },
    {
        title: 'Artificial Intelligence',
        description: 'Harnessing AI-powered solutions, from predictive analytics to automation, to drive innovation and smarter business strategies.',
        image: '6.jpg',
    },
    {
        title: 'Mechatronics',
        description: 'Innovating at the intersection of mechanics, electronics, and computing to create intelligent automation, robotics, and smart systems.',
        image: '10.jpg',
    },
    {
        title: ' Data intelligence',
        description: 'Leveraging big data technologies and advanced analytics to extract valuable insights, optimize operations, and support smart decision-making.',
        image: '4.jpg',
    },

];
const AboutUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const navigate = useNavigate();
    return (
        <div>
            <div className="relative w-full h-[500px] sm:h-[400px] md:h-[600px] lg:h-[700px] xl:h-[800px] bg-[#f4fafe]">
                <img
                    src="/our_team.webp"
                    alt="codify"
                    className="w-full h-full object-cover "
                />
                <div className="absolute inset-0 flex flex-col items-start justify-center text-left px-10 sm:px-16 md:px-20 lg:px-24 bg-black/40">
                    <h1 className="text-3xl w-1/2 sm:text-4xl md:text-4xl lg:text-6xl text-white font-bold font-poppins leading-snug sm:leading-tight">
                        Our Team is Your Team
                    </h1>
                    <p className="text-base w-1/2 sm:text-lg md:text-xl lg:text-2xl text-white font-poppins mt-4">
                        Experience, Rigor, and a User-Centric Approach.
                    </p>
                </div>
            </div>
            <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-1/2 mb-8 md:mb-0">
                    <h1 className="text-3xl pl-10 mt-12 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins sm:mb-8 leading-snug sm:leading-tight">
                        Hello, we’re Codify.
                    </h1>
                    <p className="text-base font-poppins pl-10 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:text-md md:text-xl text-[#211E33] mb-4 sm:mb-6 leading-normal">
                        Our DNA is made of ex-startup founders and the top talent in Product, UX/UI, Software development, and Machine & Deep Learning. We came together from various backgrounds with one vision: to bring a lean, user-centric approach to product innovation and software development by completely understanding the business needs before building anything.
                    </p>
                    <div className="pl-10 mt-12 md:pl-10 lg:pl-20 sm:pl-5 mb-4 sm:mb-6">
                        <Button
                            variant="outlined"
                            className="border-2 border-[#96226E] px-6 py-2 font-poppins font-bold text-[#96226e] text-sm rounded-full sm:text-md sm:px-8 sm:py-3 hover:text-white hover:bg-[#96226E] transition duration-300"
                            onClick={() => navigate("/work")}
                        >
                            See Our Work
                        </Button>
                    </div>
                </div>
                <div className="md:w-3/4 flex justify-center  mt-6 lg:mt-0 mb-6 sm:mb-10">
                    <img src="/codify_team.webp" alt="Codify" className="  w-5/6 object-cover" />
                </div>
            </div>
            <div>
                <div className="relative">
                    <h1 className="text-3xl pl-10 mt-12 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins  sm:mb-8 leading-snug sm:leading-tight">
                        Want to know more about Codify? Quick facts here!
                    </h1>
                </div>
                <div className="xl:pl-20 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-8 mt-20 relative z-10">
                    {services.map((service, index) => (
                        <div key={index} className="flex justify-center">
                            <Card className="w-full max-w-xs shadow-2xl font-poppins hover:shadow-lg bg-white bg-opacity-80">
                                <CardBody className="flex flex-col items-start">
                                    <div className="mb-4">{service.icon}</div>
                                    <Typography variant="h5" color="blue-gray" className="pl-2 mb-2 font-poppins w-full">
                                        {service.title}
                                    </Typography>
                                    <Typography className="w-full font-poppins">{service.description}</Typography>
                                </CardBody>
                                <CardFooter className="pt-0"></CardFooter>
                            </Card>
                        </div>
                    ))}
                </div>

            </div>
            <div>
                <div className="relative">
                    <h1 className="text-3xl pl-10 mt-12 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins  sm:mb-8 leading-snug sm:leading-tight">
                        You can totally count on us when you’re in need of
                    </h1>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-8">
                    {services2.map((service, index) => (
                        <div key={index} className="relative h-[35rem] flex flex-col items-end justify-center overflow-hidden rounded-lg bg-white">

                            <div
                                className="absolute inset-0 h-full w-full bg-cover bg-center"
                                style={{ backgroundImage: `url('/${service.image}')` }}
                            >
                                <div className="absolute inset-0 h-full w-full "></div>
                            </div>


                            <div className="relative z-10 p-6 text-white">
                                <h3 className="text-2xl font-poppins font-bold">{service.title}</h3>
                                <p className="mt-2 font-poppins text-sm">{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
            <div>
                <h1 className="text-3xl pl-10 mt-12 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins sm:mb-8 leading-snug sm:leading-tight">
                    Domains that reside at the pinnacle of our expertise. Found yours?
                </h1>
                <p className="text-base font-poppins pl-10 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:text-md md:text-xl text-[#211E33] mb-4 sm:mb-6 leading-normal">
                    The successful partnership with over 450 clients gave us profound knowledge of various business domains.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-8">
                    {domains.map((domains, index) => (
                        <div key={index} className="relative h-[22rem] flex flex-col justify-end overflow-hidden rounded-lg bg-white">
                            <div
                                className="absolute inset-0 h-full w-full bg-cover bg-center"
                                style={{ backgroundImage: `url('/${domains.image}')` }}
                            >
                                <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-black/80 via-black/50"></div>
                            </div>
                            <div className="relative z-10 p-6 text-white">
                                <h3 className="text-2xl font-bold">{domains.title}</h3>
                                <p className="mt-2 text-sm">{domains.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
            <Contact/>
            <div className='mt-48'/>
        </div>
    );
};

export default AboutUs;
